import styles from "./SearchInput.module.css";
import RefreshIcon from "@mui/icons-material/Refresh";
import { PulseLoader } from "react-spinners";

export default function LoadMore({ loading, hasMore, setPage }) {
  if (!hasMore) return <span />;

  return (
    <div
      className={styles["cpv-search-loadmore"]}
      variant="text"
      id="wrp_container"
    >
      {loading ? (
        <PulseLoader
          size={13}
          margin={10}
          loading
          speedMultiplier={1.5}
          // For web component color is #0a717c, and for non-web component below color
          color="white"
        />
      ) : (
        <span
          className={styles["cpv-search-refresh"]}
          onClick={() => setPage((prev) => prev + 1)}
        >
          mehr anzeigen {">"}
          {">"}
        </span>
      )}
    </div>
  );
}
